module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._c;
  return _c('div', {
    staticClass: "menu-bar bg-light-green"
  }, [(_vm.loggedIn) ? _c('div', _vm._l((_vm.items), function(item, index) {
    return _c('router-link', {
      staticClass: "btn menu-action color-dark-grey",
      attrs: {
        "to": item.path
      }
    }, [_c('i', {
      class: 'fa fa-' + item.icon + ' color-white'
    }), _c('span', [_vm._v(_vm._s(item.title))])])
  })) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-291bb43f!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/AppMenu.vue
// module id = 408
// module chunks = 2